import React, { useMemo } from 'react';
import { useDrop, useDrag } from 'react-dnd';
import { getBenchSlotCount, ItemTypes } from './Constants.js';
import PlayerCardMini from '../cards/PlayerCardMini.jsx';

const BenchSlot = ({
                     slotNumber,
                     player,
                     position,
                     onPlayerDrop,
                     onPositionChange,
                     formationPositions,
                     onRemoveSub,
                     onSubstituteClick,
                     color
                   }) => {
  // Надежное определение мобильных тач-устройств
  const isTouchDevice = useMemo(() => {
    if (typeof window === 'undefined') return false;
    return ('ontouchstart' in window) && window.matchMedia('(max-width: 1024px)').matches;
  }, []);

  const [{ isOver, canDrop }, drop] = useDrop(() => ({
    accept: ItemTypes.PLAYER,
    drop: (item) => onPlayerDrop(item.playerInfo, slotNumber),
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
      canDrop: !!monitor.canDrop(),
    }),
  }), [slotNumber, onPlayerDrop]);

  const [{ isDragging }, drag] = useDrag(() => ({
    type: ItemTypes.PLAYER,
    item: { playerInfo: player },
    canDrag: !!player && !isTouchDevice,
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }), [player, isTouchDevice]);

  // Чистая переменная без дублирования
  const isActive = isOver && canDrop;

  const handleSelectChange = (event) => {
    onPositionChange(slotNumber, event.target.value);
  };

  const handleRemoveClick = (event) => {
    event.stopPropagation();
    if (player) {
      onRemoveSub(player.wyId);
    }
  };

  return (
      <div
          ref={(node) => {
            if (!node) return;
            drag(node);
            drop(node);
          }}
          className={`bench-slot p-3 rounded text-sm text-gray-400 text-center cursor-pointer transition-colors duration-150 relative ${
              isActive ? 'drop-active' : (canDrop ? 'drop-hover' : '')
          }`}
          style={{
            opacity: isDragging ? 0.5 : 1,
            cursor: player && !isTouchDevice ? 'grab' : 'pointer',
          }}
          onClick={(e) => onSubstituteClick(e, slotNumber)}
      >
        <div className="bench-slot__content">
          {player ? (
              <div className="bench-slot__card">
                <PlayerCardMini
                    player={{ ...player, position: position || player.position }}
                    showRating
                />
              </div>
          ) : (
              <div className="icon" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <span
                    className="player-ico icon-t-shirt"
                    style={{ fontSize: '48px', color: color || '#0040FF', width: '100%', height: '100%' }}
                />
              </div>
          )}
          <div className="title-block">
            {player && (
                <button
                    className="remove-sub-button icon-s-cross"
                    onClick={handleRemoveClick}
                    title="Remove player"
                />
            )}
            {!player && <span className="name" />}
            <div className="position">
              <div className="score_val score_field"></div>
              {player && (
                  <select
                      value={position || ''}
                      onChange={handleSelectChange}
                      onClick={(e) => e.stopPropagation()}
                      className={`bench-position-select${position ? '' : ' bench-position-select--empty'}`}
                  >
                    <option value="" disabled>Select Pos.</option>
                    {formationPositions.map((pos, index) => {
                      const val = pos.position || pos.title;
                      return <option key={index} value={val}>{val}</option>;
                    })}
                  </select>
              )}
            </div>
          </div>
        </div>
      </div>
  );
};

const SubstitutesSection = ({
                              subs,
                              onSubsChange,
                              formationPositions,
                              onPositionChange,
                              onRemoveSub,
                              onSubstituteClick,
                              color
                            }) => {
  // useMemo защищает от пересоздания массива при каждом рендере
  const benchSlots = useMemo(() => {
    return Array.from({ length: getBenchSlotCount(subs) }, (_, i) => {
      const slotNumber = i + 1;
      const subInSlot = subs.find(sub => sub.slot === slotNumber);
      return {
        slotNumber,
        player: subInSlot?.playerInfo || null,
        position: subInSlot?.position || null,
      };
    });
  }, [subs]);

  return (
      <div className="substitutes-container">
        <h4 style={{ marginBottom: '1rem' }}>Substitutes</h4>
        <div className="bench-slots-grid">
          {benchSlots.map(({ slotNumber, player, position }) => (
              <BenchSlot
                  key={slotNumber}
                  slotNumber={slotNumber}
                  player={player}
                  position={position}
                  onPlayerDrop={onSubsChange}
                  onPositionChange={onPositionChange}
                  formationPositions={formationPositions}
                  onRemoveSub={onRemoveSub}
                  onSubstituteClick={onSubstituteClick}
                  color={color}
              />
          ))}
        </div>
      </div>
  );
};

export default SubstitutesSection;
